<div class="it-topbar">
	<div class="it-topbar-left">
		<div class="it-appdot" aria-hidden="true"></div>
		<div class="it-appname">Integration Tester</div>

		<div class="it-crumb">/</div>
		<div class="it-crumb it-crumb-strong">{{ integrationCrumb }}</div>

		<div class="it-crumb">/</div>
		<div class="it-crumb it-crumb-strong">{{ requestName }}</div>
	</div>

	<button type="button" class="it-themebtn" (click)="toggleTheme.emit()">
		<span class="it-themeicon" aria-hidden="true"></span>
		<span class="it-themetext">{{ theme === 'dark' ? 'Dark' : 'Light' }}</span>
	</button>
</div>
